import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import congratulation from "./../../../Images/congratulation-img.png";
import "./howttotradetron.css";
function howttotradetron(props) {
  //console.log(props);
  return (
    <>
     <section className="howtostart_section">
            <div className="howtostart_main">
            <div className="container">
            <div class="page_heading"><h2><span>How to Start</span></h2></div>
            <div className="row justify-content-center">
            <div className="col-md-11">
                  <div className="howtostart_grid">
                  <div className="howtostart_group">
                    <div className="howtostart_panel media align-items-center">
                      <div className="howtostart_icon">
                          <span>1</span>
                      </div>
                      <div className="howtostart_text media-body">
                        <p>Register with Moneysukh and then Sign-up with <strong>Tradetron</strong></p>
                      </div>
                    </div>
                  </div>
                  <div className="howtostart_group">
                    <div className="howtostart_panel media align-items-center">
                      <div className="howtostart_text media-body">
                        <p>Login to Tradetron and Go to <a href="https://tradetron.tech/strategies">Strategy Marketplace</a></p>
                      </div>
                      <div className="howtostart_icon">
                          <span>2</span>
                      </div>
                    </div>
                  </div>
                  <div className="howtostart_group">
                    <div className="howtostart_panel media align-items-center">
                      <div className="howtostart_icon">
                          <span>3</span>
                      </div>
                      <div className="howtostart_text media-body">
                        <p>Click on subscribe</p>
                      </div>
                    </div>
                  </div>
                  <div className="howtostart_group">
                    <div className="howtostart_panel media align-items-center">
                      <div className="howtostart_text media-body">
                        <p>Navigate to "My Strategies" and look for the above subscribed <br></br> strategy under "Subscribed."</p>
                      </div>
                      <div className="howtostart_icon">
                          <span>4</span>
                      </div>
                    </div>
                  </div>
                  <div className="howtostart_group">
                    <div className="howtostart_panel media align-items-center">
                      <div className="howtostart_icon">
                          <span>5</span>
                      </div>
                      <div className="howtostart_text media-body">
                        <p>Click on “Deploy”. Choose the default settings of “Paper Trading’ and  “TT PaperTrading” as broker <small>(Moneysukh has been added as a default when you sign up)</small></p>
                      </div>
                    </div>
                  </div>
                  <div className="howtostart_group">
                    <div className="howtostart_panel media align-items-center">
                      <div className="howtostart_text media-body">
                        <p>To track the strategy on the “Deployed” page, if it shows active, it means it’s working well. During market hours, this strategy will take some positions daily.</p>
                      </div>
                      <div className="howtostart_icon">
                          <span>6</span>
                      </div>
                    </div>
                  </div>
                  </div>
                  </div>
            </div>
            </div>
            </div>
      </section>

      <section className="congratulation_section">
      <div className="container">
        <div class="page_heading"><h2>Congratulations!</h2></div>
        <div className="congratulation_text text-center">
              <div className="congratulation_img">
                <img className="img-fluid" src={congratulation} alt="congratulation" />
              </div>
              <h3>You've just put your first <br></br>Algo strategy into action.</h3>
        </div>
      </div>
</section>
      <section className="ctest_section py-5 d-none">
      <div className="container">
        <div class="page_heading"><h2>fgfdf!</h2></div>
        <div className="congratulation_text text-center">
              <div className="congratulation_img">
                <img className="img-fluid" src={congratulation} alt="congratulation" />
              </div>
              <h3>You've just put your first <br></br>Algo strategy into action.</h3>
        </div>
      </div>
</section>
    </>
  );
}
export default howttotradetron;
